import sanitizeHtml from 'sanitize-html'

export const sanitizeUserHtml = (html: string): string => sanitizeHtml(html)
